export const SET_USE_SEMANTIC_SEARCH = (T) => `SET_USE_SEMANTIC_SEARCH_${T.toUpperCase()}`;

export const SEMANTIC_SEARCH_ACTION_NAMES = {};

(() => {
    [
        'article',
        'guide',
        'itinerary',
        'landing_page'
    ].forEach((entityType) => {
        const key = entityType.toUpperCase();
        SEMANTIC_SEARCH_ACTION_NAMES[key] = {};
        SEMANTIC_SEARCH_ACTION_NAMES[key]['SET_USE_SEMANTIC_SEARCH'] = SET_USE_SEMANTIC_SEARCH(key);
    });
})();
